import { render, staticRenderFns } from "./AddHall.vue?vue&type=template&id=09ed15c2&scoped=true&"
import script from "./AddHall.vue?vue&type=script&lang=js&"
export * from "./AddHall.vue?vue&type=script&lang=js&"
import style0 from "./AddHall.vue?vue&type=style&index=0&id=09ed15c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ed15c2",
  null
  
)

export default component.exports